import { atom } from 'jotai';

const dealerNumberAtom = atom<string>('');

export { dealerNumberAtom };
